// src/pages/TrackCreation/Step1.tsx
import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Button from "../ui/Button";
import shell from "../../pages/track/create/createShell.module.css";

interface Subcategory {
    name: string;
    step: string;
}

interface SidebarItem {
    title: string;
    step?: string;
    hasSubcategories: boolean;
    subcategories?: Subcategory[];
}

const MuseumZonesSidebar: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { t: rawT } = useTranslation();
    const t = rawT as any;

    // Replaces the current "zone-*" segment with the new step.
    const replaceStepInUrl = (newStep: string): string => {
        return location.pathname.replace(/zone-[^/]+/, newStep);
    };

    // Extract a value from the URL using a regex pattern.
    const extractValueFromPattern = (): string | null => {
        const regex = /^\/create\/tour\/[^/]+\/zone-[^/]+\/[^/]+\/([^/]+)$/;
        const match = location.pathname.match(regex);
        return match ? match[1] : null;
    };

    // Determine whether to show extra subcategories based on extracted URL value.
    const additionalSubcategories = extractValueFromPattern() !== null;

    const sidebarItems: SidebarItem[] = [
        {
            title: t("zoneDetails"),
            hasSubcategories: true,
            subcategories: [
                { name: t("language"), step: "zone-language" },
                ...(additionalSubcategories ? [{ name: t("info"), step: "zone-info" }] : []),
            ],
        },
    ];

    return (
        <div className={`track-create-sidebar-navigation ${shell.navRoot}`}>
            <ul className={`track-create-sidebar-nav ${shell.navList}`}>
                {sidebarItems.map((item, index) => (
                    <div key={index} className={shell.navGroup}>
                        {!item.hasSubcategories ? (
                            <li
                                className={`sidebar-title ${shell.navTitleLink} ${
                                    item.step && location.pathname.includes(item.step) ? shell.navTitleLinkActive : ""
                                }`}
                            >
                                <Link to={replaceStepInUrl(item.step || "")} className="sidebar-link">
                                    {item.title}
                                </Link>
                            </li>
                        ) : (
                            <>
                                <li className={`sidebar-title sidebar-group-title ${shell.navHeading}`}>
                                    {item.title}
                                </li>
                                <ul className={`subcategory-list ${shell.navSubList}`}>
                                    {item.subcategories?.map((sub, subIndex) => (
                                        <li
                                            key={subIndex}
                                            className={`${shell.navSubItem} ${
                                                location.pathname.includes(sub.step) ? shell.navSubItemActive : ""
                                            }`}
                                        >
                                            <Link to={replaceStepInUrl(sub.step)} className="sidebar-link">
                                                {sub.name}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </>
                        )}
                    </div>
                ))}
            </ul>
            <Button
                label={t("backToGeneral")}
                variant="outline"
                shape="pill"
                className={shell.navBackBtn}
                onClick={() => {
                    navigate(location.pathname.replace(/\/zone-[^/]+\/.+$/, "/museum-architecture"));
                }}
            />
        </div>
    );
};

export default MuseumZonesSidebar;
